<template>
	<div v-loading="loading">
		<div class="title-div">
			<!-- 标题 -->
			<span class="title">关键字配置</span>
			<!-- 新增按钮 -->
			<div style="float: right;">
				<a @click="addMultiple=addMultiple == 0 ? 1 : 0">
					<i class="el-icon-cpu"></i>
					{{ addMultiple ? '关键字设置' : '批量添加' }}
				</a>
			</div>
		</div>

		<!-- 单个添加关键字 -->
		<div v-if="addMultiple == 0" style="margin-top: 30px;">
			<table class="table-vdoing">
				<thead>
				<tr>
					<th width="20%">关键字</th>
					<th width="20%">搜索页码</th>
					<th width="20%">类目</th>
					<th width="20%">追踪间隔(小时)</th>
					<th width="10%">
						<el-button type="primary" size="small" @click="addTablLine(null,null)">增加</el-button>
					</th>
				</tr>
				</thead>
				<tbody>
				<tr v-show="keywordList.length == 0">
					<td colspan="7"><span class="noData">NO DATA</span></td>
				</tr>

				<tr v-show="keywordList.length >= 1" :key="index" v-for="(item, index) in keywordList">
					<td>
			 				<span>
								<el-input v-model="item.keyword"></el-input>
							</span>
					</td>
					<td>
			 				<span>
								<el-input-number disabled :min="1" :max="10" @change="item.changed=true"
									v-model="item.endPage"></el-input-number>
							</span>
					</td>
					<td>
			 				<span>
			 					<el-select disabled v-model="item.categoryId">
			 						<el-option label="ALL Departments" value=""></el-option>
			 					</el-select>
			 				</span>
					</td>
					<td>
			 				<span>
								<el-input-number :min="2" :max="48" @change="item.changed=true"
									v-model="item.period"></el-input-number>
							</span>
					</td>
					<td>
						<span><el-button type="danger" @click="cancelInsertLine(null,index)">删除</el-button></span>
					</td>
				</tr>
				</tbody>
			</table>
		</div>

		<!-- 批量添加关键字 -->
		<div v-else>
			<div class="add-keyword-main-div">
				<el-row :gutter="20">
					<el-col :span="8">
						<div style="text-align: center; margin-bottom: 15px;">
							<el-row>
								<el-input type="textarea"
									:placeholder="'多个关键字,' + '\n' + '请用换行分割,按住ctrl + Enter可以换行,输入完毕请按回车键'"
									v-model="inputValue" :rows="4" @keyup.enter.native="handleInputConfirm"></el-input>
							</el-row>

						</div>
						<div class="add-keywords-tag-box add-keywords-tag-box-202204190633">
							<div class="tag-div" v-for="(tag,index) in keywordList" :key="index">
								<span>{{ tag.keyword }}</span>
								<a @click="cancelInsertLine(null,index)" style="margin-left: 10px;"
									class="el-icon-close"></a>
							</div>
						</div>
					</el-col>
					<el-col :span="16">
						<el-tabs type="border-card">
							<el-tab-pane label="热词">
								<div v-loading="hotLoading">
									<el-table :data="tabData" height="370">
										<el-table-column label="关键字" show-overflow-tooltip>
											<template slot-scope="scope">
												<el-button type="success"
													:disabled="addKeywordBtnDisabled(scope.row.keyword.trim())"
													@click="addTablLine(null,scope.row.keyword)"
													v-if="checkKeywordInKeywordIndex(null,scope.row.keyword) == -1"
													icon="el-icon-plus" circle></el-button>
												<el-button
													@click="cancelInsertLine(null,keywordList.map(i => i.keyword).indexOf(scope.row.keyword))"
													v-else type="danger" icon="el-icon-minus" circle></el-button>
												<span style="margin-left: 15px;">{{ scope.row.keyword }}</span>
											</template>
										</el-table-column>
										<el-table-column label="搜索量" width="100" align="center">
											<template slot-scope="scope">
												<span>{{ scope.row.search_volume }}</span>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</el-tab-pane>
							<el-tab-pane label="高频词">
								<div class="add-keywords-box">
									<el-button class="overflow-one-line" @click="hotKeywordClick(item.word)"
										:disabled="addKeywordBtnDisabled(item.word.trim()) "
										:type="checkKeywordInKeywordIndex(null,item.word) != -1? 'primary' : ''"
										v-for="(item,index) in searchData.frequencies" :key="index"
										style="margin: 5px;max-width: 300px;">
										{{ item.word }}
									</el-button>
								</div>
							</el-tab-pane>
						</el-tabs>
					</el-col>
				</el-row>
				<div class="add-keyword-config-div">
					<el-form label-width="100">
						<el-row>
							<el-col :span="8">
								<el-form-item label="搜索页码">
									<el-input-number disabled :min="1" :max="10" @change="multipleChange(null)"
										v-model="batchConfig.endPage"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="类目">
									<el-select disabled v-model="batchConfig.categoryId">
										<el-option label="ALL Departments" value=""></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="追踪间隔(小时)">
									<el-input-number @change="multipleChange(null)" :min="2"
										v-model="batchConfig.period"></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>

					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { api_asin_keywordsRelatedList } from '@/components/api/asinBasiceInfo.js'
import { getcheckedKeywordList } from '@/components/common/keyword/keyword.js'

export default {
	name: 'addGood',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg'],
	mixins: [getcheckedKeywordList],
	data() {
		return {
			loading: false,
			hotLoading: false,
			addMultiple: 1,
			keywordList: [],
			inputVisible: false,
			inputValue: '',
			batchConfig: {
				startPage: 1,
				endPage: 3,
				categoryId: '',
				period: 8
			},
			searchData: {
				frequencies: null
			},
		}
	},
	props: {
		asinId: {
			required: true
		},
		addedKeywords: {
			type: String
		}
	},
	created() {
		if (this.addedKeywords && this.addedKeywords.length > 0) {
			this.$options.methods.addTablLine(this, this.addedKeywords)
		}
		this.$options.methods.loadData(this)
	},
	beforeDestroy() {
		this.$emit('getKeywords', this.$options.data().keywordList)
	},
	computed: {
		tabData() {
			let arr = this.$data.searchData.keywords || []
			return arr.sort((a, b) => b.search_volume - a.search_volume)
		}
	},
	components: {},
	methods: {
		multipleChange: function(this_) {
			this_ = this_ || this
			this_.$data.keywordList = this_.$data.keywordList.map(i => {
				if (!i.changed) {
					i.period = this_.$data.batchConfig.period
					i.endPage = this_.$data.batchConfig.endPage
				}
				return i
			})
		},
		checkKeywordInKeywordIndex: function(this_, keyword) {
			this_ = this_ || this
			return this_.$data.keywordList.map(i => i.keyword).indexOf(keyword)
		},
		hotKeywordClick: function(keyword) {
			let this_ = this
			let index = this_.$options.methods.checkKeywordInKeywordIndex(this_, keyword)
			if (index > -1) {
				this_.$options.methods.cancelInsertLine(this_, index)
			} else {
				this_.$options.methods.addTablLine(this_, keyword)
			}
		},
		loadData: function(this_) {
			this_ = this_ || this
			// 开启遮罩
			this_.$data.hotLoading = true
			api_asin_keywordsRelatedList(this_.asinId).then(res => {
				//关闭遮罩
				this_.$data.hotLoading = false
				this_.$data.searchData = res.data
				let keywordList = this_.$data.searchData.keywords || []
				keywordList = keywordList.map(i => i.keyword)
				this_.$options.methods.loadcheckedKeyword(this_, keywordList, this_.asinId, 'hotLoading')
			}).catch(err => {
				//关闭遮罩
				this_.$data.hotLoading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, "加载失败"), 4)
			})
		},
		handleInputConfirm(e) {
			let inputValue = this.$data.inputValue;
			if (e.ctrlKey) {
				this.$data.inputValue += '\n'
				return
			}
			this.$data.inputVisible = false;
			this.$data.inputValue = '';
			if (inputValue) {
				let input = inputValue.split(/[(\r\n)\r\n]+/)
				input.forEach(i => {
					if (i) {
						this.$options.methods.addTablLine(this, i)
					}
				})
			}
		},
		/**
		 * 去除关键字
		 */
		cancelInsertLine: function(this_, index) {
			this_ = this_ || this
			this_.$data.keywordList.splice(index, 1)
			return
		},
		/**
		 * 添加关键字
		 */
		addTablLine: function(this_, text) {
			this_ = this_ == null ? this : this_
			if (this_.$data.keywordList.length >= 20) {
				this_.F_alertMsg('一次性最多添加20个', 4)
				return
			}
			let keywordsData = JSON.parse(JSON.stringify(this_.$data.batchConfig));
			if (text) {
				keywordsData.keyword = text
			}
			this_.$data.keywordList.push(keywordsData)
		}
	},
	watch: {
		asinId: {
			handler(nval) {
				this.$options.methods.loadData(this)
			},
			deep: true
		},
		keywordList: {
			handler(nval) {
				this.$emit('getKeywords', nval)
			},
			deep: true
		},
	},
}
</script>

<style scoped="scoped">
.title-div {
	margin: 20px 0px;
	height: 40px;
	line-height: 40px;
}

.title-div .title {
	margin-left: 10px;
	font-size: 24px;
	font-weight: bold;
	color: #555;
	border-left: 5px solid red;
	padding-left: 10px;
}

.noData {
	font-size: 26px;
	font-weight: bold;
	color: #fff;
	text-shadow: 0 0 5px #000;
	display: inline-block;
	height: 60px;
	line-height: 60px;
}

.table-vdoing {
	border-collapse: collapse;
	text-align: center;
	width: 100%;
}

.table-vdoing th,
.table-vdoing td {
	padding: 10px;
	border: 1px solid #ddd;
}

.table-vdoing tr:nth-of-type(odd) {
	background-color: #f9f9f9;
}

.right-head-div {
	border-bottom: 1px solid #dcdcdc;
}

.right-table-div {
	overflow-y: auto;
}

.right-foot-div {
	margin-top: 30px;
	text-align: center;
}

.add-keywords-tag-box {
	padding: 15px 10px;
	border: 1px solid #d5d5d5;
	height: 300px;
	border-radius: 5px;
	overflow-y: auto;
}

.add-keywords-box {
	overflow-y: auto;
	height: 370px;
}

.tag-div {
	font-size: 13px;
	border-radius: 5px;
	border: 1px solid #dedede;
	padding: 10px 15px;
	margin: 5px;
	display: inline-block;

}

.add-keyword-config-div {
	text-align: center;
	margin-top: 20px;
}
</style>